const NFe = {
    "total_nfe": 0,
    "total_items": 0,
    "total_paid": 0,
    "paid_value": 0,
    "shipping_value": "0",
    "allow_payments": true,
    "identification": {
        "discount_value": 0,
        "recipient": "",
        "recipient_name": "",
        "recipient_cpf_cnpj": "",
        "recipient_city_name": "",
        "recipient_state_uf": "",
        "recipient_phone_number": "",
        "nat_op": "Venda",
        "nat_op_list": ["Venda", "Remessa", "Devolução"],
        "fat_number": "",
        "tp_nf": "1",
        "allow_ref_key": false,
        "fin_nfe": "1",
        "ind_pres": "0",
        "ind_intermed": "0",
        "allow_intermed_data": false,
        "cnpj_inter": '',
        'id_intermed': '',
        "additional_information": "",
        "is_final_consumer":'1'
    },
    "items": [],
    "payments": [],
    "transport": {
        "mod_frete": "9",
    },
    "volumes": [],
}
export default NFe


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/nfe.model.js